var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "justify-content": "space-around",
            width: "100%",
            "margin-top": "150px",
          },
        },
        [
          _c("div", { staticClass: "contactitem" }, [
            _c("div", { staticClass: "contacttitle" }, [_vm._v("电子邮箱")]),
            _c("div", { staticClass: "contactvalue" }, [
              _vm._v(" " + _vm._s(_vm.configdata.maile) + " "),
            ]),
          ]),
          _c("div", { staticClass: "contactitem" }, [
            _c("div", { staticClass: "contacttitle" }, [_vm._v("在线客服")]),
            _c(
              "div",
              { staticClass: "contactvalue" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.openservice },
                  },
                  [_vm._v("点击联系客服")]
                ),
              ],
              1
            ),
          ]),
          _vm._m(0),
        ]
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contactitem" }, [
      _c("div", { staticClass: "contacttitle" }, [_vm._v(" 固定电话")]),
      _c("div", { staticClass: "contactvalue" }, [_vm._v(" 029-81025379 ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }